const API_ENV = process.env.API_ENV;

export default (valueType = "DoubleUploadImg") => {
  return {
    Type: "upload",
    // upload 上传
    valueType,
    // preview 预览
    ocr: false,
    FormItemProps: {
      label: '双图上传',
      required: false,
      style: {}
    },
    frontProps: {
      uploadText: "",
      errorMessage: "第一张照片",
      uploadBackgroundImg: "",
      imageUrl: "",
    },
    backProps: {
      uploadText: "",
      errorMessage: "第二张照片",
      uploadBackgroundImg: "",
      imageUrl: "",
    },
    beforeUploadRules: {
      tips: "照片格式仅支持png、jpg、jpeg,且不能超过2MB大小",
      fileSize: 2,
    },
    UploadProps: {
      accept: "image/jpeg,image/png,image/jpg",
      action: `https://${API_ENV}.${API_ENV === 'lyt' ? "lieyuntong.cn" : "ailieyun.com"}/api/custom/file/upload`,
      showUploadList: false,
    },
  }
}